<template>
  <b-container fluid>
    <div class="my-3 p-3 bg-white rounded shadow-sm">
      <h4 class="border-bottom border-gray pb-2 mb-0">Cotizaciones</h4> 
     
        <JDTable
          :option="tableOptions"
          :loader="tableLoader"
          :event-from-app="eventFromApp"
          :event-from-app-trigger="eventFromAppTrigger"
          @event-from-jd-table="processEventFromApp($event)"
        />
    
    
    </div>
   
  </b-container>
</template>

<script>
import JDTable from 'vue-jd-table';
import axios from "axios";
export default {
components: {
    JDTable
  },
  data() {
    return {
      user: null,
      modalDelete: false,
      tmpid: null,
      items: [],
      quotes: [],
      fields: [
        { key: "data.servicio.snumber", label: "No. Servicio" },
        { key: "data.servicio.tarifa", label: "Tarifa CFE" },
        { key: "data.tamano", label: "Tamaño" },
        { key: "data.servicio.assignedTo.name", label: "Vendedor" },
        { key: "data.cliente.firstname", label: "Cliente" },
        { key: "data.porcentaje_cobertura", label: "Porcentaje" },
        { key: "data.servicio.city.name", label: "Ciudad" },
        { key: "createdAt", label: "Fecha agregado" },
        { key: "actions", label: "" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      filter: {},
      tableOptions: {},

      eventFromApp: {
        name: null,
        data: null,
      },

      eventFromAppTrigger: false,

      tableLoader: false,

      columns: [
        {
          name: "snumber",
          title: "No. Servicio",
          order: 1,
          type: "Number",
          filterable: true,
          enabled: true,
         
        },
        {
          name: "tarifa",
          title: "Tarifa",
          order: 2,
          type: "String",
          filterable: true,
          enabled: true, 
        },
        {
          name: "tamano",
          title: "Tamaño",
          order: 2,
          type: "Number",
          filterable: true,
          enabled: true, 
        },
        {
          name: "assignedTo",
          title: "Vendedor",
          order: 3,
          type: "String",
          filterable: true,
          enabled: true, 
        },
        {
          name: "cliente",
          title: "Cliente",
          order: 4,
          type: "String",
          filterable: true,
          enabled: true, 
        },
        {
          name: "porcentaje_cobertura",
          title: "Cobertura",
          order: 5,
          type: "String",
          filterable: true,
          enabled: true, 
        },
        {
          name: "city",
          title: "Ciudad",
          order: 6,
          type: "String",
          filterable: true,
          enabled: true, 
        },
        {
          name: "createdAt",
          title: "Fecha",
          order: 7,
          type: "String",
          filterable: true,
          enabled: true,  
        },
      ],
    };
  },
  mounted() {
    this.user = this.$store.state;
    this.listar();
     
  },
  methods: {
    listar() {
      if (this.user.usuario.rol === "Supervisor") {
        let me = this;
        axios
          .get("quotes/supervisor/" + this.user.usuario._id)
          .then(function(response) {
            me.items = response.data; 
          })
          .catch(function(error) {});
      } else {
        let me = this;
         me.tableLoader = true;
        axios
          .get("quotesShortFull")
          .then(function(response) {
            me.items = response.data; 
            me.sendData();
          })
          .catch(function(error) {});
      }
    }, 
    view(iduser) {
      this.$router.push({ name: "cotizacion_id", params: { id: iduser } });
    },
    openPDF(id) {
      window.open(
        "https://services.createchenergias.mx/pdf/?id=" +
          JSON.parse(JSON.stringify(id)) +
          "&token=" +
          this.token(),
        "_blank"
      );
    },
    token() {
      return this.$store.state.token;
    },
    modalDeletef(id) {
      this.tmpid = id;
      this.modalDelete = true;
    },
    confirmDelete() {
      let me = this;
      axios
        .delete("quotation/" + this.tmpid)
        .then(function(response) {
          me.modalDelete = false;
          me.listar();
        })
        .catch(function(error) {});
    },
    removeText(txt) {
      let tmp = txt.toString();
      return tmp.replace("Tarifa", "d ");
    },
    sendData: function() {
      // Enable the table loader.
      this.tableLoader = true;

      this.getData().then((result) => {
        this.eventFromApp = {
          name: "sendData",
          payload: result,
        };

        this.triggerEvent();

        // Disable the table loader.
        this.tableLoader = false;
      });
    },

    // Triggers the currently queued JD-Table event to run.
    triggerEvent: function() {
      // Trigger the event.
      this.eventFromAppTrigger = true;

      // Reset the trigger event.
      this.$nextTick(() => {
        this.eventFromAppTrigger = false;
      });
    },

    // Triggered when the JD-Table emits a "eventFromJDTable" event.
    processEventFromApp: function(componentState) {
      if (componentState.lastAction === "Refresh") {
        this.getData().then((result) => {
          this.eventFromApp = {
            name: "sendData",
            payload: result,
          };

          this.triggerEvent();
        });
      }
    },

    getData: function() {
      return new Promise((resolve, reject) => {
        let sampleData = this.items;
 

        resolve(sampleData);
      });
    },
  },
  created: function() {
    this.tableOptions = { 
      columns: this.columns,
    };
  },
};
</script>
 